import { Component, OnInit } from '@angular/core';
import { PortInvoiceBaseDto } from '../invoice';
import { InvoiceService } from '../invoice.service';

@Component({
  selector: 'app-dashboard',
  standalone: false,
  templateUrl: './dashboard.component.html',
  styleUrls: [ './dashboard.component.css' ]
})
export class DashboardComponent implements OnInit {
  invoices: PortInvoiceBaseDto[] = [];

  constructor(private invoiceService: InvoiceService) { }

  ngOnInit(): void {
    this.getInvoices();
  }

  getInvoices(): void {
    this.invoiceService
      .getInvoices(1147, 26, '', [])
      .subscribe(invoices => this.mapBills(invoices.portInvoiceables));
  }

  private mapBills(invoices: PortInvoiceBaseDto[]){
    return this.invoices = invoices.slice(1, 5);
  }
}